import { render, staticRenderFns } from "./groupBased.vue?vue&type=template&id=6d013644&"
import script from "./groupBased.vue?vue&type=script&lang=js&"
export * from "./groupBased.vue?vue&type=script&lang=js&"
import style0 from "./groupBased.vue?vue&type=style&index=0&id=6d013644&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/.pnpm/vue-loader@15.10.2/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports